/**
 * Closes the dropdown when user clicks outside of it.
 *
 * @param {string} dropdownParentClass - The class of the dropdown parent element.
 */
export function handleCloseDropdownOnBlur(dropdownParentClass) {
    window.addEventListener('click', (event) => {
        const dropdownParent = document.querySelector(dropdownParentClass);
        const dropdown = document.querySelector('.dropdown__options-holder');

        if (!dropdownParent || !dropdown) return;

        const isClickInsideDropdown = dropdown.contains(event.target);
        const isClickInsideDropdownParent = dropdownParent.contains(
            event.target,
        );

        if (isClickInsideDropdown || isClickInsideDropdownParent) {
            return;
        }

        dropdownParent.classList.remove('dropdown--active');
    });
}
